import React, { useEffect, useState } from 'react'
import Header from '../layout/Header'
import { formatDatee } from '../../helpers/converter'
import { Link } from 'react-router-dom'
import { connect, useDispatch } from 'react-redux'
import { getApplications } from '../../actions/application/getApplications'
import { pagingApplication } from '../../actions/v3/pagingApplications'

function ConcludedApplications(props) {
    const dispatch = useDispatch();

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const totalCount = props.pagingApplication.pagingApplications?.result.totalCount; // Sonuç modelinden gelen toplam kayıt sayısı
    const pageCount = Math.ceil(totalCount / pageSize);

    useEffect(() => {
        dispatch(pagingApplication(pageSize, page));
    }, [dispatch]);


    useEffect(() => {
        // Burada, sayfa değiştiğinde verileri yeniden yükleme işlevini tetikle
        dispatch(pagingApplication(pageSize, page));
    }, [page, pageSize, dispatch]);

    const handlePrevious = () => {
        setPage((prevPage) => (prevPage > 0 ? prevPage - 1 : prevPage));
    };

    const handleNext = () => {
        setPage((prevPage) => (prevPage < pageCount - 1 ? prevPage + 1 : prevPage));
    };

    const handlePageClick = (pageNumber) => {
        setPage(pageNumber);
    };

    return (
        <div>
            <Header />
            <div className='pt-10 md:ml-64 ps-5'>
                <ol className="flex items-center whitespace-nowrap min-w-0" aria-label="Breadcrumb">

                    <li className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200" aria-current="page">
                        Başvurularım
                    </li>
                </ol>
            </div>
            <hr className='divide-y mt-2' />
            <h1 className='text-2xl font-semibold text-start mt-5 ps-5 md:ml-64'>Tıbbi İkinci Görüş Başvurularınız</h1>
            <p class="mt-5 ps-5 md:ml-64 text-md text-gray-500 text-start mb-">
                Başvurunuzun detaylarını görüntülemek için üzerine tıklayın.
            </p>
            <div className='mb-5'>
                {props.pagingApplication.done ?
                    <div className='mt-5 ps-5 md:ml-64 pe-5'>
                        {props.pagingApplication.pagingApplications?.result?.entities.map((element, index) => {
                            return (
                                <>
                                    {element.applicationStatus === 6 ?
                                        <div key={index} class="bg-slate-100 border rounded-sm text-start mb-3">

                                            <div class="top-0 left-0 right-0">
                                                <div class="p-4 md:p-5">
                                                    <div className='flex justify-between'>
                                                        <Link
                                                            to={`/concluded-application-detail/${element.id}`}
                                                            className='text-xl font-semibold'>
                                                            {element.assignments[0].professionName}
                                                        </Link>
                                                        <p class="mt-1 text-xs text-gray-500">{formatDatee(element.createdAt)}</p>
                                                    </div>

                                                    {
                                                        element.applicationStatus === 0 ?
                                                            <p class="mt-3 mb-3 text-sm font-semibold text-gray-500">Başvurunun tamamlanması bekleniyor</p>
                                                            :
                                                            element.applicationStatus === 1 ?
                                                                <p class="mt-3 mb-3 text-sm font-semibold text-gray-500">Başvurunun tamamlanması bekleniyor</p>
                                                                :
                                                                element.applicationStatus === 10 ?
                                                                    <p class="mt-3 mb-3 text-sm font-semibold text-gray-700">Doktor kabulu bekleniyor</p>
                                                                    :
                                                                    element.applicationStatus === 3 ?
                                                                        <p class="mt-3 mb-3 text-sm font-semibold text-red-800">Doktor tarafından reddedildi</p>
                                                                        :
                                                                        element.applicationStatus === 6 ?
                                                                            <p class="mt-3 mb-3 text-sm font-semibold onedose-color">Başvuru sonuçlandırıldı</p>
                                                                            :
                                                                            element.applicationStatus === 2 ?
                                                                                <p class="mt-3 mb-3 text-sm font-semibold onedose-color">Başvuru kabul edildi </p>
                                                                                : null
                                                    }
                                                    <p><b>Başvuru yapılan hekim : </b>{element.assignments[0].doctor.name + " " + element.assignments[0].doctor.lastName}</p>
                                                    <>
                                                        {element.applicationStatus === 0 || element.applicationStatus === 1 ?
                                                            <p className='mt-1'>
                                                                <Link
                                                                    to={`/file-uploadv2/${element.id}`}
                                                                    className="text-red-400 mt-3"
                                                                >
                                                                    <i class="fa-light fa-upload d-flex align-items-center me-1"></i>
                                                                    Dosya eklemesi yapabilirsiniz.
                                                                </Link>

                                                            </p>
                                                            : null}

                                                    </>

                                                </div>
                                            </div>
                                        </div>

                                        : null}
                                </>
                            )
                        })}
                    </div>
                    : null}
                {props.pagingApplication.spinner ?
                    <div class="relative mt-5 ps-5 pe-5 md:ml-64">
                        <div class="bg-yellow-50 border border-red-200 rounded-md p-4">
                            <div class="flex">

                                <div class="ml-3 text-start">
                                    <h3 class="text-sm text-red-800 font-medium">
                                        Detaylar Yükleniyor
                                    </h3>
                                    <div class="text-sm text-red-700 mt-2">
                                        <span class="font-semibold">Lütfen bekleyin!</span> Başvuru detaylarınız getiriliyor.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="absolute top-0 left-0 w-full h-full bg-white/[.5] rounded-md dark:bg-gray-800/[.4]"></div>
                        <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <div class="animate-spin inline-block w-6 h-6 border-[3px] border-current border-t-transparent text-red-600 rounded-full" role="status" aria-label="loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    : null}

            </div>
            <nav className="flex items-center gap-x-1 pt-10 md:ml-64 ps-5 float-right me-5">
                <button
                    onClick={handlePrevious}
                    disabled={page === 0}
                    className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex items-center justify-center text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                    {/* Geri butonu SVG ve metni burada */}
                    <span>Geri</span>
                </button>
                <div className="flex items-center gap-x-1">
                    {Array.from({ length: pageCount }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => handlePageClick(index)}
                            aria-current={page === index ? 'page' : undefined}
                            className={`min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-sm rounded-lg focus:outline-none focus:bg-gray-100 ${page === index ? 'disabled:opacity-50 disabled:pointer-events-none' : ''} dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10`}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
                <button
                    onClick={handleNext}
                    disabled={page === pageCount - 1}
                    className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex items-center justify-center text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 dark:text-white dark:hover:bg:white/10 dark:focus:bg:white/10"
                >
                    {/* İleri butonu SVG ve metni burada */}
                    <span>İleri</span>
                </button>
            </nav>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};

export default connect(mapStateToProps)(ConcludedApplications);